<template>
  <inertia-link :href="goto"
                class="inline-flex uppercase items-center text-sm font-medium leading-5 transition duration-150 ease-in-out"
                :class="classes" v-if="!samePage">
    <slot></slot>
  </inertia-link>
  <a :href="goto"
     class="inline-flex uppercase items-center text-sm font-medium leading-5 transition duration-150 ease-in-out"
     :class="classes" v-if="samePage" v-smooth-scroll>
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    href: {},
    active: {},
    smoothScroll: {
      type: Boolean,
      default: false
    },
    anchor: {},
    samePage: {
      default: false
    },
    footer: {
      default: false
    }
  },

  computed: {
    classes() {
      if (this.footer) {
        return 'text-white'
      } else if (this.active) {
        return 'px-1 py-3 lg:py-6 xl:border-b-2 xl:border-medium-blue focus:outline-none xl:focus:border-medium-blue text-dark-blue xl:text-white'
      } else {
        return 'px-1 py-3 xl:py-6 xl:border-b-2 border-transparent xl:hover:border-white focus:outline-none focus:text-white focus:border-white text-dark-blue xl:text-white '
      }
    },

    goto() {
      if (this.samePage) {
        return this.anchor
      } else {
        return this.href + (this.anchor ?? '')
      }
    }
  }
}
</script>
